module.exports = __webpack_public_path__ + "img/indiefolio-img.ad803cfd.png";